/* eslint-disable @typescript-eslint/naming-convention */
import { inject, Injectable } from '@angular/core';
import 'node_modules/@types/gtag.js/index.d.ts';
import { Title } from '@angular/platform-browser';

/**
 * Add missing params on Gtag interface
 */
declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace Gtag {
    interface ConsentParams {
      ad_user_data?: 'granted' | 'denied';
      ad_personalization?: 'granted' | 'denied';
    }
  }
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private readonly _titleService = inject(Title);
  /**
   * Send screen_view event to Google Analytics
   * it's used to track the screen name
   *
   * @param screenName screen name
   * @returns void
   */
  public screen_view(screenName: string, screenSubName?: string) {
    const eventData: { app_name: string; screen_name: string; screen_subname?: string } = {
      app_name: this._titleService.getTitle(),
      screen_name: screenName,
    };

    if (screenSubName) {
      eventData.screen_subname = screenSubName;
    }
    if (window.gtag) {
      window.gtag('event', 'screen_view', eventData);
    }
  }

  /**
   * Send event to Google Analytics
   * its used to track custom events
   *
   * @param eventName event name
   * @param eventData event data
   * @returns void
   */
  public customEvent(eventName: string, eventData: { [key: string]: string }) {
    if (window.gtag) {
      window.gtag('event', eventName, eventData);
    }
  }
}
